import { useContext } from 'react';
import classNames from 'classnames';
import { NoteBreadcrumbs } from '@nx-frontend/shared/components';
import { MenuItem } from '@nx-frontend/shared/types';
import { TopbarContext } from './topbar-context';

export interface TopbarProps {
  children: React.ReactNode;
  breadcrumbsArea?: React.ReactNode;
  hideBreadcrumbs?: boolean;
  noteMenuItem?: MenuItem | null;
  showButtomBack?: boolean;
  isCreateBreadcrumbs?: boolean;
  bradcrumbsWrapperClassName?: string;
  cy?: string;
}

export function Topbar(props: TopbarProps) {
  const {
    children,
    breadcrumbsArea,
    hideBreadcrumbs,
    showButtomBack = true,
    isCreateBreadcrumbs = true,
    cy,
    bradcrumbsWrapperClassName,
  } = props;
  const { noteMenuItem } = useContext(TopbarContext) || {};

  return (
    <div
      data-cy={cy}
      className="topbar flex items-center h-16 shrink-0 px-4 gap-8 border-b-[1px] border-solid border-neutral-200 bg-white box-border z-[1]"
    >
      {!hideBreadcrumbs ? (
        <div className={classNames('overflow-hidden text-ellipsis grow', bradcrumbsWrapperClassName)}>
          {breadcrumbsArea ? (
            breadcrumbsArea
          ) : (
            <NoteBreadcrumbs
              noteMenuItem={noteMenuItem}
              showButtomBack={showButtomBack}
              isCreateBreadcrumbs={isCreateBreadcrumbs}
            />
          )}
        </div>
      ) : null}
      {children}
    </div>
  );
}
